<template>
  <v-container></v-container>
</template>

<script>
import api from "@/services/api";
export default {
  name: "Auth",
  mounted() {
    api.isToken();
  },
};
</script>

<style></style>
